
// 国际化
import Vue from 'vue'

import router from '@main/common/router'

import directive from '@main/common/directive' // directive
import pinia from '@main/common/pinia'
import { PiniaVuePlugin, setMapStoreSuffix } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import i18n from '@main/common/lang'
import Element from 'element-ui'
import App from './App.vue'

import 'element-ui/lib/theme-chalk/index.css'
import '@main/common/assets/style/index.scss'
import '@main/common/assets/style/common.scss'
import '@main/common/assets/icon/iconfont.css'
import './common/config/autoUiComponents.js'
import './permission'

export { buttonIcons } from './common/utils/buttonIcon'
export { scrollTo } from './common/utils/scroll-to'

Vue.config.productionTip = false
pinia.use(piniaPluginPersistedstate)
setMapStoreSuffix('_pinia')
Vue.use(PiniaVuePlugin)

Vue.use(directive)

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)

const messages = ['success', 'warning', 'info', 'error']

messages.forEach((type) => {
  Element.Message[type] = (options) => {
    let resetOptions = options
    if (typeof resetOptions === 'string') {
      resetOptions = {
        message: resetOptions
      }
      resetOptions.duration = 5000
    }
    resetOptions.type = type
    return Element.Message(resetOptions)
  }
})
Vue.use(Element, { size: 'medium', zIndex: 3000 })
// Vue.prototype.$message.success = function (msg) {
//   return Message.success({
//     message: msg,
//     duration: 3000
//   })
// }
// Vue.prototype.$message.warning = function (msg) {
//   return Message.warning({
//     message: msg,
//     duration: 3000
//   })
// }
// Vue.prototype.$message.error = function (msg) {
//   return Message.error({
//     message: msg,
//     duration: 1500
//   })
// }
new Vue({
  router,
  pinia,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
